// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"37377322","266":"3faf6c65","588":"8d9d3295","634":"12585495","729":"f27fe1b6","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};